/**
 * Where a guest's filing stands with the national reporting system — mirrors
 * `pkg/enums/RegistrationStatus` on the API.
 *
 * Sent and Confirmed are two different facts and are never merged: the reporting
 * system took the message, and the reporting system says it stands. A hotel that reads
 * the first as the second learns the difference from an inspector.
 */
export enum RegistrationStatus {
    Pending   = 'pending',
    Sent      = 'sent',
    Confirmed = 'confirmed',
    Failed    = 'failed',
    Cancelled = 'cancelled',
}
